/* Smartly Cooked – free gift guard.
   Free gifts (and the Lifetime Updates add-on) only belong in the cart next to a paid book.
   Remove a book and the matching free gift disappears with it; empty the books and everything goes. */
(function () {
  if (window.scGiftGuard) return;
  window.scGiftGuard = true;

  var SOURCE = 'gift-guard';
  var busy = false;

  function isGift(item) {
    var handle = String(item.handle || '');
    return /^free-gift/i.test(handle) || (Number(item.final_line_price) === 0 && /gift/i.test(handle));
  }

  function isAddon(item) {
    return String(item.handle || '') === 'lifetime-updates';
  }

  function cartUrl(path) {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + path;
  }

  function check() {
    if (busy) return;
    busy = true;

    fetch(cartUrl('.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var bookQty = 0;
        items.forEach(function (item) {
          if (!isGift(item) && !isAddon(item)) bookQty += item.quantity;
        });

        var updates = {};
        var remaining = bookQty;
        var changed = false;

        items.forEach(function (item) {
          if (isGift(item)) {
            var allowed = Math.max(0, Math.min(item.quantity, remaining));
            remaining -= allowed;
            if (allowed !== item.quantity) { updates[item.key] = allowed; changed = true; }
          } else if (isAddon(item) && bookQty === 0) {
            updates[item.key] = 0;
            changed = true;
          }
        });

        if (!changed) return null;

        var body = {
          updates: updates,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        };
        var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        };

        return fetch(cartUrl('/update.js'), Object.assign({}, config, { body: JSON.stringify(body) }))
          .then(function (response) { return response.json(); })
          .then(function (state) {
            if (state.status) throw new Error(state.description || state.message || 'Unable to update the cart.');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && state.sections && typeof drawer.renderContents === 'function') drawer.renderContents(state);
            syncEmptyState();
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && state.sections && state.sections['cart-icon-bubble']) {
              var html = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
              var inner = html.querySelector('.shopify-section');
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: state });
            }
            return state;
          });
      })
      .catch(function (error) { console.error('[gift-guard]', error); })
      .finally(function () { busy = false; });
  }

  // The drawer's empty state is decided server-side (gift/lifetime-only carts count as empty),
  // but the outer <cart-drawer> class is only toggled by the theme from item_count. Keep it in sync.
  function syncEmptyState() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var isEmpty = !!drawer.querySelector('.drawer__inner-empty');
    drawer.classList.toggle('is-empty', isEmpty);
    var items = drawer.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', isEmpty);
  }

  var observeTimer = null;
  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.scGiftGuardObserved) return;
    drawer.scGiftGuardObserved = true;
    new MutationObserver(function () {
      syncEmptyState();
      clearTimeout(observeTimer);
      observeTimer = setTimeout(check, 120);
    }).observe(drawer, { childList: true, subtree: true });
    syncEmptyState();
  }

  function listen() {
    observe();
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(listen, 150);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      // Let the theme finish its own re-render first.
      setTimeout(check, 50);
    });
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listen);
  else listen();
})();
